<template>
  <section class="bg-white p-6 border rounded-md border-gray-200 ">
    <div class="flex items-center gap-3 mb-4">
      <div class="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center overflow-hidden flex-shrink-0">
        <img v-if="student?.photo" :src="student.photo" alt="Student photo" class="w-full h-full object-cover" />
        <i v-else class="pi pi-user text-primary text-lg"></i>
      </div>
      <h3 class="font-semibold text-lg text-gray-700">
         {{ student?.surname}} {{ student?.first_name }} {{ student?.other_name }} 
      </h3>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-6 text-md">
      <div class="space-y-2">
        <p><strong>Matric No:</strong> {{ student?.matric_no }}</p>
        <p><strong>Email:</strong> {{ student?.email }}</p>
        <p><strong>Gender:</strong> {{ student?.gender }}</p>
        <p><strong>Date of Birth:</strong> {{ formatDate(student?.dob) }}</p>
      </div>
      <div class="space-y-2">
        <p><strong>Phone:</strong> {{ student?.phone }}</p>
        <p v-for="row in originRows" :key="row.label" :data-testid="`student-origin-${row.label}`">
          <strong>{{ row.label }}:</strong> {{ row.value }}
        </p>
      </div>
    </div>

    <StudentLinkingCodePanel v-if="student" :studentId="String(student.id)" :linkingCode="student.linking_code" @refresh="emit('refresh')" />
  </section>
</template>

<script setup lang="ts">
import type { Student } from '@/types/composition-functions';

import dayjs from 'dayjs';
import { computed } from 'vue';
import { originDisplayRows } from '@/utils/studentOrigin';
import StudentLinkingCodePanel from './StudentLinkingCodePanel.vue';

const props = defineProps<{
  student: Student | null
}>();

const emit = defineEmits<{ (e: 'refresh'): void }>();

// Nationality, residential address, state of residence and city each get
// their own labelled row (#574) instead of one ambiguous "Address". State of
// origin, LGA and a permanent address are custom fields on the profile card.
const originRows = computed(() => originDisplayRows(props.student ?? {}));

function formatDate(date: string | null | undefined) {
  if (!date) return 'N/A';
  return dayjs(date).format('MMMM D, YYYY');
}
</script>
